// @flow
import React, { useEffect, useState, useMemo } from 'react';
import Cookies from 'js-cookie';
// Components
import { SearchBar } from '../../search';
import { CurrentUserIndicator } from '../../user';
import { CartIndicator } from '../../current-order';
import { BigClubIndicator } from '../../user';
import { Link, useLocation } from 'react-router-dom';
import { RepeatLastPurchase } from '../../common';
import Logo from '../components/Logo';
import BigClubButton from './BigClubButton';
// Styles
import './TopRow.css';
// Assets
import logoHorizontal from '../images/logoHorizontal.svg';
// Helpers
import { useSessionStorage } from '../../common';

type Props = {
  orderNumber: string,
  order: Order[],
  orders: Order[],
  prevOrderItems: LineItem[],
  currentOrderItems: LineItem[],
  getPastOrder: (orderNumber: string) => void,
  copyingOrder: (
    currentOrderNumber: string,
    previousOrderNumber: string,
  ) => void,
  currentOrderNumber: string,
  previousOrderNumber: string,
  loggedIn: boolean,
  loggingInLoading: boolean,
  validatingUserLoading: boolean,
  featuresConfigLoading: boolean,
};

const TopRow = (props: Props) => {
  const location = useLocation();
  const shouldClosePopup =
    !props.loggingInLoading && props.currentOrderItems?.length > 0;

  const showBigClubInformation =
    !!props.userId && props.bigClubInformation?.totalAvailableBigclubCredit > 0;

  const linkTo = !!props.userId ? '/bigclub' : '/lp/bigclub';
  const [shouldShowPopup, setShouldShowPopup] = useState(
    Cookies.get('should_show_popup') === undefined
      ? true
      : Cookies.get('should_show_popup') === 'true',
  );

  const shouldShowRepeatLastPurchase =
    shouldShowPopup && window.location.pathname === '/' && !shouldClosePopup;

  const handleClosePopup = () => {
    Cookies.set('should_show_popup', false, { expires: 1, path: '/' });
    setShouldShowPopup(false);
  };

  useEffect(() => {
    if (location.pathname !== '/' || shouldClosePopup) {
      handleClosePopup();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, props.loggedIn, props.loggingInLoading]);

  return (
    <div className="toprow-main">
      <Logo />
      <SearchBar />
      <Link to="/" className="toprow-main-container">
        <img
          className="toprow-main-logo"
          src={logoHorizontal}
          alt="logo BigDelivery"
        />
      </Link>

      <BigClubButton
        bigClubEnabled={props.bigClubEnabled}
        bigClubInformation={props.bigClubInformation}
        featuresConfigLoading={props.featuresConfigLoading}
        validatingUserLoading={props.validatingUserLoading}
        redirectLink={linkTo}
        showBigClubInformation={showBigClubInformation}
      />

      <CurrentUserIndicator />

      <CartIndicator />

      {shouldShowRepeatLastPurchase && (
        <RepeatLastPurchase
          orderNumber={props.orderNumber}
          order={props.order}
          orders={props.orders}
          getPastOrder={props.getPastOrder}
          copyingOrder={props.copyingOrder}
          currentOrderNumber={props.currentOrderNumber}
          previousOrderNumber={props.previousOrderNumber}
          copyingOrderLoading={props.copyingOrderLoading}
          handleClosePopup={handleClosePopup}
          shouldShowPopup={shouldShowPopup}
          prevOrderItems={props.prevOrderItems}
          currentOrderItems={props.currentOrderItems}
        />
      )}
    </div>
  );
};

export default TopRow;
